import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Col, Form, Modal, Row } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import validator from "validator";

import ApiHelper from "../../../Helpers/ApiHelper";
import Overlay from "../../SharedComponents/Overlay";
import TalentTurkLogo from "./TalentTurkLogo";
import CusProLogo from "./CusProLogo";
import AdminBreadCrumb from "../../Admin/AdminBreadCrumb";
import Image from "react-bootstrap/Image";

const PWD_Regex = /^(?=.*[a-z])(?=.*[^a-zA-Z\d\s:])(?=.*[A-Z])(?=.*[0-9]).{6,24}$/;

const NewRegister = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [validation, setValidation] = useState({
    mail: null,
    password: null,
    name: null,
    confirmPassword: null,
  });

  const [modal, setModalShow] = useState({
    show: false,
  });

  let errorStrings = {
    mail: t("invalidEmail"),
    password: t("passwordCheckRules"),
    name: t("requiredField"),
    confirmPassword: t("passwordsDoNotMatch"),
  };

  let checkValidationAndSet = (value, inputType) => {
    if (inputType === "mail") {
      setState((state) => ({ ...state, email: value }));
      if (!validator.isEmail(value)) {
        setValidation((validation) => ({ ...validation, mail: true }));
      } else {
        setValidation((validation) => ({ ...validation, mail: false }));
      }
    } else if (inputType === "password") {
      setState((state) => ({ ...state, password: value }));

      if (value === "" || !PWD_Regex.test(value)) {
        setValidation((validation) => ({ ...validation, password: true }));
      } else {
        setValidation((validation) => ({ ...validation, password: false }));
      }
    } else if (inputType === "confirmPassword") {
      setState((state) => ({ ...state, confirmPassword: value }));
      if (value !== state.password) {
        setValidation((validation) => ({
          ...validation,
          confirmPassword: true,
        }));
      } else {
        setValidation((validation) => ({
          ...validation,
          confirmPassword: false,
        }));
      }
    } else if (inputType === "name") {
      setState((state) => ({ ...state, username: value }));

      if (value === "") {
        setValidation((validation) => ({ ...validation, name: true }));
      } else {
        setValidation((validation) => ({ ...validation, name: false }));
      }
    }
  };

  let onSubmit = (event) => {
    event.preventDefault();
    setShowOverlay(true);
    ApiHelper.postAsync("user/register", state, function (result) {
      setShowOverlay(false);
      if (result.status !== 200) {
        setModalShow(() => ({
          show: true,
          text: result.data?.message || t("requestFailed"),
          heading: "Hata",
          success: false,
        }));
      } else if (result && result.data.statusCode) {
        setModalShow(() => ({
          show: true,
          text: t("registerSuccessMessage"),
          heading: t("registerSuccess"),
          success: true,
        }));
      } else if (result && !result.data.statusCode) {
        setModalShow(() => ({
          show: true,
          text: result.data.data,
          heading: "Hata",
          success: false,
        }));
      }
    });
  };

  let modalClose = () => {
    if (modal.success) navigate("/login");
    else setModalShow(false);
  };

  const [showOverlay, setShowOverlay] = useState(false);

  return (
    <>
      {showOverlay && <Overlay text={t("registerOverlayMessage")} />}
      <Modal centered show={modal.show} onHide={modalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modal.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.text}</Modal.Body>
        <Modal.Footer className={"justify-content-center"}>
          <Button className="button primary w-100 py-2" onClick={modalClose}>
            {modal.success === true ? t("login") : t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Row className={"vh-100"}>
        <Col xs={"auto"} className={"d-none position-relative d-lg-block p-0"} style={{ width: 500 }}>
          <div className={"top-0 bottom-0 position-absolute z-0"}>
            <Image
              src={"/LandingPageImages/puzzleLight.webp"}
              alt="example"
              style={{
                width: "500px",
                height: "100vh",
                objectFit: "cover", // key: makes image fill and crop
                objectPosition: "center", // optional: center the crop
              }}
            />
          </div>

          <div className={"top-0 bottom-0 start-0 end-0 position-absolute z-1"}>
            <Row className={"justify-content-between ms-3 me-1 mt-2"}>
              <Col xs={"auto"} className={"mt-1"}>
                <CusProLogo size={40} fill={"#fff"} />
              </Col>
              <Col xs={"auto"}>
                <TalentTurkLogo size={40} fill={"#fff"} />
              </Col>
            </Row>
          </div>
        </Col>
        <Col xs={12} lg={true}>
          <Row className={"mt-2 mx-0 "}>
            <Col xs={"auto"}>
              <AdminBreadCrumb className={"mb-0"} backUrl={"/"}></AdminBreadCrumb>
            </Col>
            <Col className={"p-0"}></Col>
            <Col xs={"auto"} className={"text-color-gray-light align-content-center d-none d-sm-block"}>
              {t("alreadyHaveAnAccount?")}
            </Col>
            <Col xs={"auto"}>
              <Button className={"button secondary h-100"} onClick={() => navigate("/login")}>
                {t("login")}
              </Button>
            </Col>
          </Row>
          <Form className={"mt-5 pt-4"} onSubmit={onSubmit}>
            <Row className={"justify-content-center"}>
              <Col xs={9} xxl={7}>
                <Row className={"text-color-gray-dark text-24 fw-medium"}> {t("createNewCusProAccount")}</Row>

                <Row className={"mt-5"}>
                  <Col>
                    <Row className={"text-color-gray-light"}> {t("emailLabel")}</Row>
                    <Row>
                      <Form.Group className={"p-0"}>
                        <Form.Control
                          className={"default-text-input"}
                          type="email"
                          placeholder={t("emailInputPlaceholder")}
                          onChange={(e) => checkValidationAndSet(e.target.value, "mail")}
                          isInvalid={validation.mail}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">{errorStrings.mail}</Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                  </Col>
                </Row>
                <Row className={"mt-4"}>
                  <Col>
                    <Row className={"text-color-gray-light"}> {t("yourName")}</Row>
                    <Row>
                      <Form.Group className={"p-0"}>
                        <Form.Control
                          className={"default-text-input"}
                          type="text"
                          placeholder={t("pleaseEnterYourName")}
                          onChange={(e) => checkValidationAndSet(e.target.value, "name")}
                          isInvalid={validation.name}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">{errorStrings.name}</Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                  </Col>
                </Row>
                <Row className={"mt-4"}>
                  <Col>
                    <Row className={"text-color-gray-light"}> {t("password")}</Row>
                    <Row>
                      <Form.Group className={"p-0"}>
                        <Form.Control
                          className={"default-text-input"}
                          type="password"
                          placeholder={t("passwordPlaceholderMessage")}
                          onChange={(e) => checkValidationAndSet(e.target.value, "password")}
                          isInvalid={validation.password}
                        />
                        <Form.Control.Feedback type="invalid">{errorStrings.password}</Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                  </Col>
                </Row>
                <Row className={"mt-4"}>
                  <Col>
                    <Row className={"text-color-gray-light"}> {t("passwordAgain")}</Row>
                    <Row>
                      <Form.Group className={"p-0"}>
                        <Form.Control
                          className={"default-text-input"}
                          type="password"
                          placeholder={t("pleaseEnterYourPasswordAgain")}
                          onChange={(e) => checkValidationAndSet(e.target.value, "confirmPassword")}
                          isInvalid={validation.confirmPassword}
                        />
                        <Form.Control.Feedback type="invalid">{errorStrings.password}</Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                  </Col>
                </Row>

                <Row className={"mt-5"}>
                  <Col className={"p-0 pt-4   "}>
                    <Button
                      className={"button primary w-100 py-2"}
                      type="submit"
                      disabled={
                        validation.mail === false &&
                        validation.name === false &&
                        validation.password === false &&
                        validation.confirmPassword === false
                          ? false
                          : true
                      }
                    >
                      {t("Register")}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
};
export default NewRegister;
